import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';

export default function AlertDialog({ data, field, handleClose, message, open, title }) {
  return (
    <div>
      <Dialog
        open={open}
        // onClose={(handleClose2}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{message}</DialogContentText>
          {data && (
            <Typography variant='body1' component='div'>
              {data.map((element) => `${element[field]}, `)}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <BasicButton handleClick={() => handleClose(true)} type='accept' />
          <BasicButton handleClick={() => handleClose(false)} type='cancel' />
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
AlertDialog.propTypes = {
  data: PropTypes.array,
  field: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
